import useUser from '@vl-core/hooks/useUser';

/**
 * Renders children only if the current user's role code matches one of the supplied prop roles (either "admin",
 * "hbsadmin" or "audit" or "referrer"). Note that the role codes are case insensitive.
 *
 * @param children
 * @param roles (case insensitive) some combination of audit | hbsadmin | admin | referrer
 * @returns {null|*}
 * @constructor
 */

export type RoleCode =
  | 'admin'
  | 'super'
  | 'audit'
  | 'referrer'
  | 'conf'
  | 'hbsadmin'
  | 'custserv'
  | 'reporting'
  | 'clinician'
  | 'clinlead'
  | 'patient'
  | 'ops';

export function SuppressForRoleCode({ children, ...role_codes }: any) {
  const user = useUser();
  const userRoleCode = user.user_role_code || {};

  for (const role in role_codes) {
    if (role_codes[role] && role.toUpperCase() === userRoleCode) {
      return null;
    }

    if (
      ![
        'admin',
        'super',
        'audit',
        'referrer',
        'conf',
        'hbsadmin',
        'custserv',
        'reporting',
        'clinician',
        'clinlead',
        'patient',
        'ops'
      ].includes(role.toLowerCase())
    ) {
      throw Error(`Bad role specified for "DisplayForRoles": "${role}"`);
    }
  }

  return children;
}

export default SuppressForRoleCode;
